import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M15.73 3.05698C15.566 2.96998 15.367 2.98298 15.212 3.09098L10.999 6.03998V4.00098C10.999 2.89798 10.102 2.00098 8.999 2.00098H2C0.897 1.99998 0 2.89698 0 3.99998V12C0 13.103 0.897 14 2 14H9C10.103 14 11 13.103 11 12V9.96098L15.213 12.91C15.299 12.97 15.4 13 15.5 13C15.579 13 15.658 12.981 15.73 12.943C15.896 12.857 16 12.686 16 12.5V3.49998C16 3.31298 15.896 3.14298 15.73 3.05698Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }